import Card from "../Card/Card";

function AccomodationSection(props) {
  return (
    <section className="accomodations">
      <div className="container container--accomadation">
        {props.accomodations.map((accomodation) => {
          return (
            <Card
              key={accomodation._id}
              title={accomodation._title}
              cover={accomodation._cover}
              id={accomodation._id}
            />
          );
        })}
      </div>
    </section>
  );
}

export default AccomodationSection;
